var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',[_c('Card',{staticClass:"mt-4",attrs:{"title":_vm.$t('notifications.notification_list')}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }